import React from 'react';

function TransactionField(props) {
  let classes = 'font-museo font-w-300 leading-22 text-17 mb-15 md:mb-20 ' + props.classes;

  return (
    <div className={classes}>
      <div className="font-w-600">{props.label}: </div>
      <span className={props.sensitive ? 'tealeaf-mask' : ''}>{props.content}</span>
    </div>
  );
}

export default TransactionField;
